<template>
  <div v-if="isPreview" class="preview-message" :class="{ 'preview-message--collapsed': collapsed }" role="alert" aria-live="polite">
    <button type="button" class="preview-message__header" :aria-expanded="!collapsed" @click="collapsed = !collapsed">
      <span class="preview-message__dot"></span>
      <span class="preview-message__badge">PREVIEW</span>
      <span class="preview-message__version">v{{ previewVersion }}</span>
      <span class="preview-message__chevron" :class="{ 'preview-message__chevron--open': !collapsed }">▾</span>
    </button>
    <div v-show="!collapsed" class="preview-message__body">
      <span v-if="previewId" class="preview-message__item">Shortsite code: {{ previewId }}</span>
      <span v-if="previewEntityId" class="preview-message__item">Entity ID: {{ previewEntityId }}</span>
      <span v-if="formattedCreatedAt" class="preview-message__item">Created: {{ formattedCreatedAt }}</span>
      <span v-if="previewGeneratedBy" class="preview-message__item">By: {{ previewGeneratedBy }}</span>
      <!-- <span class="preview-message__notice">Unpublished draft — not live</span> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewBanner',
  data() {
    return {
      collapsed: false
    }
  },
  computed: {
    isPreview() {
      return this.$store.getters['UI/isPreview']
    },
    previewVersion() {
      return this.$store.getters['UI/previewVersion']
    },
    previewTag() {
      return this.$store.getters['UI/previewTag']
    },
    previewEntityId() {
      return this.$store.getters['UI/previewEntityId']
    },
    previewId() {
      return this.$store.getters['UI/previewId']
    },
    previewCreatedAt() {
      return this.$store.getters['UI/previewCreatedAt']
    },
    previewGeneratedBy() {
      return this.$store.getters['UI/previewGeneratedBy']
    },
    formattedCreatedAt() {
      if (!this.previewCreatedAt) {
        return ''
      }
      const date = new Date(this.previewCreatedAt)
      return isNaN(date.getTime()) ? this.previewCreatedAt : `${date.toLocaleString('en-GB', { timeZone: 'UTC' })} UTC`
    },
    label() {
      const tag = this.previewTag || 'preview'
      return tag.charAt(0).toUpperCase() + tag.slice(1)
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-message {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  flex-flow: column;
  align-items: center;
  max-width: 320px;
  background: rgba(253, 232, 232, 0.92);
  color: #8a1f1f;
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  line-height: 1.3;
  text-align: center;
  border-bottom-right-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(2px);

  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    margin: 0;
    padding: 5px 10px;
    background: transparent;
    border: none;
    color: inherit;
    font: inherit;
    cursor: pointer;
  }

  &__dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #c0392b;
    flex: 0 0 auto;
  }

  &__badge {
    font-weight: 700;
    letter-spacing: 0.05em;
  }

  &__version {
    display: inline-block;
    padding: 0 6px;
    background: rgba(138, 31, 31, 0.12);
    border-radius: 3px;
    font-weight: 700;
  }

  &__chevron {
    font-size: 10px;
    opacity: 0.7;
    transition: transform 0.15s ease;

    &--open {
      transform: rotate(180deg);
    }
  }

  &__body {
    display: flex;
    flex-flow: column;
    align-items: center;
    gap: 1px;
    padding: 0 10px 6px;
    text-align: center;
  }

  &__item {
    font-weight: 400;
    opacity: 0.9;
  }

  &__notice {
    margin-top: 2px;
    font-weight: 600;
    opacity: 0.85;
  }
}
</style>
